import React, { Component } from 'react';
import { connect } from 'react-redux';
import {DragDrop} from "@uppy/react";
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import FaceCanvas from "../components/Face/FaceCanvas";
import { setFaceImage, toggleLoading, closeTour } from "../actions";
import 'react-image-crop/dist/ReactCrop.css';
import FaceCropper from "../components/Face/FaceCropper";
import FacePosition from "../components/Face/FacePosition";
import Tour from "reactour";
import CurvedArrow from "../components/CurvedArrow";

class FaceContainer extends Component {

  UNSAFE_componentWillMount() {
    this.uppy = new Uppy({
      restrictions: {  },
      autoProceed: true,
      allowedFileTypes: ['image/*', '.heic',  '.heif']
    });

    this.uppy.use(XHRUpload, {
      endpoint: window.tProjectGlobals.baseUrl + '/designer/upload',
      method: 'post',
      formData: true,
      fieldName: 'files'
    });

    this.uppy.on('upload', () => {
      this.props.toggleLoading(true);
      this.props.closeTour(0);
    })

    this.uppy.on('upload-success', (file, {body}) => {
      //console.log(file, body);
      this.props.setFaceImage({
        src: body.url,
        width: body.width,
        height: body.height,
        name: body.name
      });
    });
  }

  renderEditor() {
    if (this.props.meishi.faceImage) {
      if (this.props.meishi.finalImage) {
        return (
          <FacePosition />
        );
      } else if (this.props.meishi.cropped) {
        return (
          <FaceCanvas/>
        );
      } else {
        return (
          <FaceCropper image={this.props.meishi.faceImage} />
        );
      }

    } else {
      return (
        <React.Fragment>
          <div className="t-content-right-bottom-area">
            <div className="t-container-placeholder">顔写真をアップロードしてください</div>
          </div>
          {/*<Tour*/}
          {/*  steps={*/}
          {/*    [{*/}
          {/*      selector: '.t-container-sidebar-uppy-inside',*/}
          {/*      content: 'まずは顔写真をアップロードしましょう。\nこちらに写真をドロップするか、ここをクリックしてください',*/}
          {/*    }]*/}
          {/*  }*/}
          {/*  isOpen={this.props.meishi.tour[0]}*/}
          {/*  onRequestClose={() => { this.props.closeTour(0) }}*/}
          {/*  showNumber={false}*/}
          {/*/>*/}
        </React.Fragment>
      );
    }
  }

  renderTitle() {
    if (this.props.meishi.faceImage) {
      if (this.props.meishi.finalImage) {
        return (
          <div className="phase-title">
            <small>STEP3</small>
            <span>位置の調整</span>
          </div>
        );
      } else if (this.props.meishi.cropped) {
        return (
          <div className="phase-title">
            <small>STEP2</small>
            <span>顎ラインのトリミング</span>
          </div>
        );
      } else {
        return (
          <div className="phase-title">
            <small>STEP1</small>
            <span>顔写真のアップロード</span>
          </div>
        );
      }
    } else {
      return (
        <div className="phase-title">
          <small>STEP1</small>
          <span>顔写真のアップロード</span>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="t-content t-face-container">
        <div className="t-content-left">
          {this.renderTitle()}

          {!this.props.meishi.croppedImage &&  (
            <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
              <div className="t-container-sidebar-content">
                <h3>画像の追加</h3>

                <div className="t-container-sidebar-uppy">
                  <div className="t-container-sidebar-uppy-inside">
                    <DragDrop uppy={this.uppy} note="対応形式: JPEG, PNG, GIF, AI, PSD, SVG" locale={{
                      strings: {
                        dropHereOr: '画面に画像をドロップするか、%{browse}してください。',
                        // Used as the label for the link that opens the system file selection dialog.
                        browse: 'ファイルから選択'
                      }
                    }} />
                  </div>
                </div>

                {!this.props.meishi.faceImage && (
                  <div className="t-tutorial">
                    <div className="t-tutorial-arrow" />
                    まずは顔写真をアップロードしましょう。
                    こちらに写真をドロップするか、ここをクリックしてください。
                    {this.props.meishi.tour[0] && (
                      <CurvedArrow
                        className="arrow-blink"
                        fromSelector=".t-tutorial-arrow"
                        toSelector=".t-container-sidebar-uppy"
                        color="#1991EB"
                        zIndex={1000}
                        dynamicUpdate={true}
                        fromOffsetY={10}
                      />
                    )}
                  </div>
                )}

                {this.props.meishi.faceImage && (
                  <div className="t-tutorial">
                    <div className="t-tutorial-arrow" />
                    名刺に印刷したい部分の範囲を指定しましょう。目安は目からあご下、両耳が入るサイズです。<br />
                    <img src={window.tProjectGlobals.assetBaseUrl + "img/tutorial-1.png"} alt="" />
                    {this.props.meishi.tour[1] && (
                      <CurvedArrow
                        className="arrow-blink"
                        fromSelector=".t-tutorial-arrow"
                        toSelector=".ReactCrop"
                        color="#1991EB"
                        zIndex={1000}
                        dynamicUpdate={true}
                        fromOffsetX={95}
                      />
                    )}
                  </div>
                )}

              </div>
            </div>
          )}

          {(this.props.meishi.faceImage && !this.props.meishi.finalImage && this.props.meishi.cropped) && (
            <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
              <div className="t-container-sidebar-content">

                <div className="t-tutorial">
                  <div className="t-tutorial-arrow" />
                  消しゴムツールを使って顎ラインのトリミングを行います。
                  {this.props.meishi.tour[2] && (
                    <CurvedArrow className="arrow-blink" fromSelector=".t-tutorial-arrow" toSelector=".tour-2" color="#1991EB" zIndex={1000} dynamicUpdate={true} fromOffsetX={95} />
                  )}
                </div>

                <div className="t-tutorial">
                  <div className="t-tutorial-arrow-2" />
                  修復ツールでは消しすぎた箇所を復元することができます。
                  {this.props.meishi.tour[2] && (
                    <CurvedArrow className="arrow-blink" fromSelector=".t-tutorial-arrow-2" toSelector=".tour-3" color="#1991EB" zIndex={1000} dynamicUpdate={true} fromOffsetX={95} />
                  )}
                </div>

                <div className="t-tutorial-img">
                  <img src={window.tProjectGlobals.assetBaseUrl + "img/tutorial-2.png"} alt="" />
                </div>
              </div>
            </div>
          )}

          {(this.props.meishi.faceImage && this.props.meishi.finalImage) && (
            <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
              <div className="t-container-sidebar-content">
                <div className="t-tutorial">
                  <div className="t-tutorial-arrow" />
                  マスクで隠れている部分を名刺に載せます。<br />
                  だいたい頬骨より下が入るよう調整しましょう。
                </div>

                <div className="t-tutorial">
                  <div className="t-tutorial-arrow" />
                  グレーの部分は印刷されませんが、グレーの部分いっぱいまで画像を配置してください。
                </div>

                <div className="t-tutorial-img">
                  <img src={window.tProjectGlobals.assetBaseUrl + "img/tutorial-3.png"} alt="" />
                </div>
              </div>
            </div>
          )}

        </div>
        <div className="t-content-right t-content-right-flex">
          {this.renderEditor()}
        </div>

      </div>
    );
  }
}

export default connect(f => f, {setFaceImage, toggleLoading, closeTour})(FaceContainer);


// WEBPACK FOOTER //
// ./src/containers/FaceContainer.js